import { render, staticRenderFns } from "./editLeaveworkflow.vue?vue&type=template&id=3bf660da&scoped=true"
import script from "./editLeaveworkflow.vue?vue&type=script&lang=js"
export * from "./editLeaveworkflow.vue?vue&type=script&lang=js"
import style0 from "./editLeaveworkflow.vue?vue&type=style&index=0&id=3bf660da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf660da",
  null
  
)

export default component.exports